<template>
  <div class="itemBox">
    <div class="instInputWrap">
      <div class="instCheckBoxFlexWrap">
        <div class="instCheckBoxWrap">
          <input type="checkbox" v-model="value.isActive" :true-value="item.trueValue" :false-value="item.falseValue"
                 :id="'box'+index">
          <svg viewBox="0 0 37 23" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:style="{fill:calcFill}" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11.504.43C12.767.359 14.027.365 15.29.365h6.396c1.287 0 2.548-.006 3.81.067 1.147.065 2.264.205 3.376.517a11.075 11.075 0 015.864 3.968 11.098 11.098 0 010 13.44 11.08 11.08 0 01-5.864 3.97c-1.112.311-2.23.45-3.376.516-1.262.073-2.523.067-3.785.067h-6.398c-1.286 0-2.546.006-3.809-.067-1.146-.066-2.263-.205-3.376-.517A11.08 11.08 0 010 11.637a11.1 11.1 0 012.265-6.72A11.076 11.076 0 018.128.946c1.113-.311 2.23-.45 3.376-.516z"/></svg>
          <div class="instCheckBoxMarker" v-bind:class="{trueValue: value.isActive === item.trueValue}"></div>
        </div>
      </div>
    </div>
    <div class="instBoxDesc">
      <h4>{{ value.Print_Title }}</h4>
      <p>{{ calcTxt }} Стоимость услуги: {{ value.Cost | moneyFormat }} руб.</p>
      <div>
        <div v-on:click="toggleDescription" class="toggleLink">
          <p>Подробнее →</p>
          <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z" fill="#8A919C"/><rect x="9" y="9" width="2" height="6" rx="1" fill="#8A919C"/><rect x="9" y="5" width="2" height="2" rx="1" fill="#8A919C"/></svg>
        </div>
        <p v-show="showDescription">{{ value.Print_Info }}</p>
        <p v-show="showDescription">{{ value.Print_Discription }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "instBoxItem",
  data() {
    return {
      item: {
        trueValue: 1,
        falseValue: 0,
      },
      showDescription: false
    }
  },
  props: {
    index: {
      type: Number,
      default() {
        return 0;
      }
    },
  },
  methods: {
    toggleDescription($event) {
      $event.preventDefault();
      this.showDescription = !this.showDescription
    },
  },
  computed: {
    calcTxt() {
      let out = '';
      switch (this.value.Id) {
        case 1:
          out = 'Сертификат на дистанционные юридические консультации «Личный адвокат».';
          break;
        case 2:
          out = 'Срочные телемедицинские консультации с дежурными врачами (врач общей практики, терапевт, педиатр), доступные круглосуточно, 7 дней в неделю, 365 дней в году — без ограничений по количеству обращений.';
          break;
        case 3:
          out = 'Самочувствие и здоровье – Вопросы охраны и порядка оказания медицинской помощи. Содействие в записи пациента к врачу, на обследования и диспансеризацию. 15 закрытых обращений по вопросам любого сервисного блока.';
          break;
        case 4:
          out = 'Страховая компания разделит финансовые риски, связанные с временной нетрудоспособностью, компенсируя затраты на лечение и госпитализацию.';
          break;
        case 8:
          out = 'Сертификат на дистанционные юридические консультации «Личный адвокат».';
          break;
      }
      return out;
    },
    ...mapState({
      boxArr: state => state.instForm.boxArr,
    }),
    value: {
      get() {
        return this.boxArr[this.index];
      },
      set(newValue) {
        this.$store.dispatch('instUpdateBoxItem', {
          index: this.index,
          value: newValue
        })
      }
    },
    calcFill() {
      if (this.value.isActive !== this.item.trueValue && this.value.isActive !== this.item.falseValue) {
        return 'var(--color-gray-type2)'
      }
      return this.value.isActive === this.item.trueValue ? 'var(--color-green)' : 'var(--color-red-type2)';
    },

  }
}
</script>

<style scoped>
.itemBox {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  border-radius: var(--font-size-04);
  padding: var(--font-size-28) var(--font-size-10);
  border: var(--font-size-02) solid var(--color-gray-type2);
  margin: var(--font-size-28) 0
}

h4 {
  margin: 0;
  font-size: var(--font-size-16);
  font-weight: 500
}

.instBoxDesc p {
  font-size: var(--font-size-14);
  margin: var(--font-size-08) 0 var(--font-size-16);
  color: var(--color-gray-type3)
}

.instInputWrap {
  margin: 0
}

.toggleLink {
  display: flex;
  align-items: center;
  justify-content: space-between
}

.toggleLink p {
  color: var(--color-green);
  font-size: var(--font-size-14)
}

.toggleLink svg {
  width: var(--font-size-24);
  height: var(--font-size-24)
}

</style>